import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.3185 2.11122C13.1651 1.79623 10.6098 1.79632 8.44883 2.11113C5.14699 2.59505 2.60514 5.14655 2.11188 8.43343L2.11134 8.43711C1.95295 9.51897 1.875 10.6711 1.875 11.875C1.875 13.0789 1.95305 14.2317 2.11145 15.3136C2.59579 18.6056 5.1399 21.1455 8.43665 21.6383L8.43989 21.6388C9.52202 21.7971 10.6745 21.875 11.8708 21.875C13.0674 21.875 14.2194 21.797 15.3089 21.639L15.3108 21.6387C18.6047 21.1545 21.145 18.6027 21.6381 15.3166L21.6387 15.3129C21.7971 14.231 21.875 13.0789 21.875 11.875C21.875 10.6768 21.806 9.52301 21.6469 8.43639C21.1627 5.14556 18.61 2.59505 15.3185 2.11122Z",
  fill: "white"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M15.3912 1.61653L15.3908 1.61648C13.1893 1.29446 10.5854 1.29459 8.37675 1.61635L8.37633 1.61641C4.85539 2.13244 2.14319 4.85572 1.61741 8.35922L1.61716 8.361L1.61662 8.36468C1.4543 9.4733 1.375 10.6498 1.375 11.875C1.375 13.1002 1.45441 14.2774 1.61672 15.386L1.61677 15.3864C2.13334 18.8974 4.84932 21.6076 8.36273 22.1328L8.36347 22.1329L8.36671 22.1334L8.36752 22.1335C9.4763 22.2957 10.6532 22.375 11.8708 22.375C13.0888 22.375 14.265 22.2957 15.3807 22.1338L15.3811 22.1337L15.383 22.1334L15.3835 22.1334C18.8968 21.617 21.607 18.8931 22.1326 15.3908L22.1327 15.3896L22.1333 15.386L22.1334 15.3853C22.2957 14.2767 22.375 13.1002 22.375 11.875C22.375 10.6582 22.305 9.47961 22.1416 8.36395L22.1416 8.36361C21.6252 4.85424 18.9009 2.13243 15.3912 1.61653Z",
  stroke: "black",
  "stroke-opacity": "0.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12L11 7.50001C11 6.94772 11.4477 6.50001 12 6.50001C12.5523 6.50001 13 6.94772 13 7.50001L13 11.5858L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.2929 12.7071Z",
  fill: "black",
  "fill-opacity": "0.4"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2BadgeEarlyRoundColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2BadgeEarlyRoundColor as default
};
